export const authConfig = {
  identityPoolId: import.meta.env.VITE_AUTH_IDENTITY_POOL_ID as string,
  identityPoolIdpName: import.meta.env.VITE_AUTH_IDENTITY_POOL_IDP_NAME as string,
  identityPoolRegion: import.meta.env.VITE_AUTH_IDENTITY_POOL_REGION as string,
  unauthRoleArn: import.meta.env.VITE_AUTH_UNAUTH_ROLE_ARN as string,
};

export const apiConfig = {
  apiBaseUri: import.meta.env.VITE_API_BASE_URI as string | undefined,
};

export const rumConfig = {
  appMonitorId: import.meta.env.VITE_RUM_APP_MONITOR_ID as string | undefined,
};

export const gmtConfig = {
  enabled: import.meta.env.VITE_GTM_ENABLED && import.meta.env.VITE_GTM_ENABLED === 'true',
  config: {
    gtmId: 'GTM-WKWRXD',
    dataLayerName: 'dataLayer',
  },
};

export const featureConfig = {
  researchFacetEnabled:
    import.meta.env.VITE_RESEARCH_FACET_ENABLED && import.meta.env.VITE_RESEARCH_FACET_ENABLED === 'true',
  showEventsNewsPictures:
    import.meta.env.VITE_FEATURE_SHOW_EVENTS_NEWS_PICTURES &&
    import.meta.env.VITE_FEATURE_SHOW_EVENTS_NEWS_PICTURES === 'true',
};

export const katalonConfig = {
  enabled: import.meta.env.VITE_KATALON_ENABLED === 'true',
 
};
